import { render, staticRenderFns } from "./SearchSkuDetail.vue?vue&type=template&id=45195d70"
import script from "./SearchSkuDetail.vue?vue&type=script&lang=js"
export * from "./SearchSkuDetail.vue?vue&type=script&lang=js"
import style0 from "./SearchSkuDetail.vue?vue&type=style&index=0&id=45195d70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports